// extracted by mini-css-extract-plugin
export var bodySections = "_9g-8";
export var gray = "_9g-7";
export var green = "_9g-4";
export var iconContainer = "_9g-9";
export var iconWidgetContainer = "_9g-1";
export var phoneIcon = "_9g-2";
export var red = "_9g-5";
export var statusDot = "_9g-3";
export var widgetContainer = "_9g-0";
export var yellow = "_9g-6";